import { Component, HostBinding, ViewChild, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { LineItemsBaseComponent } from "@base-components/line-items-base.component";
import { LineItemsService, LookupService, HttpService, FunctionLockService, GlobalsService, ItemsService } from '@services';
import { IInvoiceModel } from '@models';
import { SlickScreenBlockerService } from "@slick-components";
import { SlickConfirmDialogComponent, SlickConfirmDialogResults, SlickDialogComponent } from "@slick-components";

@Component({
	selector: 'line-items',
	templateUrl: 'line-items.component.html',
	styleUrls: ['line-items.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers:[ItemsService]
})
export class LineItemsComponent extends LineItemsBaseComponent {
	@HostBinding('style.flex') flex = '1';
	canSeePrice: boolean = false;
	canSeeCost: boolean = false;
	showCost: boolean = this.canSeeCost;
	@ViewChild('requestDepositRef', { static: true }) requestDepositRef: SlickDialogComponent;
	@Output() onDepositRequestSent = new EventEmitter<IInvoiceModel>();

	depositTotals: any;
	percentToRequest: number | null = 0;
	dollarAmount: number | null = null;
	totalToRequest: number = 0;
	private percentToRequestOnOpen: number | null = 0;
	private dollarAmountOnOpen: number | null = null;
	private totalToRequestOnOpen: number = 0;
	constructor(private slickScreenBlockerService: SlickScreenBlockerService,
		itemsService: ItemsService,
		lineItemsService: LineItemsService,
		lookupService: LookupService,
		httpService: HttpService,
		functionLockService: FunctionLockService) {
		super(itemsService, lineItemsService, lookupService, httpService, functionLockService);
		this.canSeePrice = GlobalsService.checkPermission("Inventory", "SeePrice");
		this.canSeeCost = GlobalsService.checkPermission("Inventory", "SeeCost");

		if (this.canSeeCost && !this.canSeePrice) {
			this.showCost = true;
		}
	}

	// All the rest of the code is in line-items-base.component.ts

	updateItemAssemblies() {
		try {
			this.slickScreenBlockerService.block();
			super.updateLathamItemAssemblies();
		}
		finally {
			this.slickScreenBlockerService.unblock();
		}
	}

	requestDeposit() {
		this.percentToRequestOnOpen = this.percentToRequest;
		this.dollarAmountOnOpen = this.dollarAmount;
		this.totalToRequestOnOpen = this.totalToRequest;
		this.requestDepositRef.showDialog();
	}

	onPercentChange() {
		if (this.percentToRequest != null) {
			this.dollarAmount = null;
			this.calculateFromPercent();
		}
	}

	onDollarChange() {
		if (this.dollarAmount != null) {
			this.percentToRequest = null;
			this.totalToRequest = this.dollarAmount;
		}
	}

	calculateFromPercent() {
		if (this.percentToRequest != null) {
			this.totalToRequest =
				(this.totals.price * this.percentToRequest) / 100;
		}
	}

	async depositRequest() {
		try {
			await this.depositRequestBase(this.percentToRequest, this.dollarAmount);
			this.requestDepositRef.hideDialog();
			const hasDepositToRequest = (this.percentToRequest != null && this.percentToRequest > 0) ||
				(this.dollarAmount != null && this.dollarAmount > 0);
			if (hasDepositToRequest) {
				this.onDepositRequestSent.emit(this.invoiceModel);
			}

			this.resetDepositForm(); // ?? clear fields
			this.requestDepositRef.hideDialog();
		} catch (error) {
			
			throw error;
		}
	}
	
	cancel() {
		this.resetDepositForm(); 
		this.requestDepositRef.hideDialog();
	}

	showRequestDepositButton() {
		return !this.invoiceModel.downPaymentPaid;
	}

	resetDepositForm() {
		this.percentToRequest = null;
		this.dollarAmount = null;
		this.totalToRequest = 0;
	}
}